import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import BigAdd from "./BigAdd";
import DOMPurify from 'dompurify';
import BollywoodNews2 from "./BollywoodNews2";
import InternationalDetails2 from "./InternationalDetails2";
import { Helmet } from "react-helmet";

const isDesktopScreen = () => window.innerWidth >= 1024;
const truncateText = (text, maxLength) => {
  if (text.length > maxLength) {
    return text.substring(0, maxLength) + "...";
  }
  return text;
};
const local = "https://localhost:44351/api/home/khelKhabars2"
const online = "https://api.shabdtoday.com/api/home/khelKhabars2"
const clicklocal = "https://localhost:44351/api/home/update-viewcount"
const clickonline = "https://api.shabdtoday.com/api/home/update-viewcount"

const stripHtmlTags = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const strippedText = tempDiv.textContent || tempDiv.innerText || "";
  return truncateText(strippedText, maxLength);
};
const renderHtmlContent = (html) => {
  const sanitizedHtml = DOMPurify.sanitize(html);
  return { __html: sanitizedHtml };
};

const truncateHtml = (html, maxLength) => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  const text = tempDiv.textContent || tempDiv.innerText || "";

  if (text.length <= maxLength) return html;

  let charCount = 0;
  let isTruncated = false;

  const traverse = (node) => {
    let newNode;
    if (node.nodeType === Node.TEXT_NODE) {
      if (charCount >= maxLength) return document.createTextNode("");
      const remaining = maxLength - charCount;
      const truncated = node.textContent.slice(0, remaining);
      charCount += truncated.length;
      if (charCount >= maxLength && !isTruncated) {
        isTruncated = true;
        newNode = document.createTextNode(truncated + "..."); // append dots
      } else {
        newNode = document.createTextNode(truncated);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      newNode = node.cloneNode(false);
      node.childNodes.forEach((child) => {
        if (charCount < maxLength) {
          newNode.appendChild(traverse(child));
        }
      });
    }
    return newNode;
  };

  const truncatedDiv = traverse(tempDiv);
  return truncatedDiv.outerHTML;
};

function Khels() {
  const [isDesktop, setIsDesktop] = useState(isDesktopScreen());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [news, setNews] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const observer = useRef();

  const fetchNews = async () => {
    if (!hasMore || fetching) return;

    setFetching(true);
    try {
      const response2 = await axios.get(`${online}?page=${page}&limit=5`);

      if (response2.data && response2.data.khelKhabars2.length > 0) {
        setNews((prevNews) => {
          const existingIds = new Set(prevNews.map((item) => item.mainKhabarId));
          const newNews = response2.data.khelKhabars2.filter((item) => !existingIds.has(item.mainKhabarId));
          return [...prevNews, ...newNews];
        });
        setPage((prevPage) => prevPage + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching news:", error.message);
    }
    setFetching(false);
    setLoading(false);
  };

  useEffect(() => {
    fetchNews();
  }, []);

  useEffect(() => {
    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchNews();
      }
    });

    const target = document.getElementById("load-more");
    if (target) observer.current.observe(target);

    return () => observer.current && observer.current.disconnect();
  }, [news]);


  const handleNewsClick2 = async (slug, mainKhabarId) => {
    try {
      const response2 = await axios.post(`${clickonline}`, {
        mainKhabarId: mainKhabarId
      });

      if (response2.status === 200) {
        // console.log("View count updated successfully", response2.data);
        window.location.href = `/News-Details/${slug}`;
      } else {
        console.error("Failed to update view count", response2.data);
      }
    } catch (error) {
      console.error("Error updating view count:", error.response2 ? error.response2.data : error.message);
    }
  };
  const baseUrl = "https://api.shabdtoday.com/";
  const image_resize = "https://api.shabdtoday.com/api/home/resize";
  return (
    <div>
      <Helmet>
        <title>खेल की ताज़ा खबरें – आज के देश दुनिया के स्पोर्ट्स न्यूज़ हिंदी में</title>
        <meta name="title" content="खेल की ताज़ा खबरें – आज के देश दुनिया के स्पोर्ट्स न्यूज़ हिंदी में | ShabdTodayz" />
        <meta name="description" content="आज की खेल दुनिया की हर ताज़ा खबर पढ़ें हिंदी में। क्रिकेट, फुटबॉल, IPL, विश्व खेल, टेनिस और अन्य स्पोर्ट्स की देश–दुनिया की सबसे तेज़ अपडेट सिर्फ ShabdToday पर।" />
        <meta name="keywords" content="खेल समाचार, स्पोर्ट्स न्यूज़ हिंदी, क्रिकेट, फुटबॉल, कबड्डी, हॉकी न्यूज़" />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ShabdToday Team" />
        <link rel="canonical" href="https://shabdtoday.com/Khel-News" />
        <meta property="og:title" content="खेल की ताज़ा खबरें – हिंदी स्पोर्ट्स न्यूज़" />
        <meta property="og:description" content="क्रिकेट, फुटबॉल, हॉकी और अन्य खेलों की ताज़ा खबरें और लाइव स्कोर हिंदी में।" />
        <meta property="og:url" content="https://shabdtoday.com/Khel-News" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://shabdtoday.com/design/images/COVER-PAGE-NEW.webp" />
        {/* <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "खेल समाचार – ShabdToday",
            "url": "https://shabdtoday.com/Khel-News",
            "description": "खेल समाचार, लाइव स्कोर और मैच अपडेट हिंदी में।",
            "publisher": {
              "@type": "Organization",
              "name": "ShabdToday",
              "logo": {
                "@type": "ImageObject",
                "url": "https://shabdtoday.com/design/images/logo-s.webp"
              }
            }
          })}
        </script> */}
      </Helmet>

      {/* <h1 className="visually-hidden">खेल समाचार हिंदी में</h1>
      <h2 className="visually-hidden">आज के मैच, स्कोर और खेल अपडेट</h2>
      <h3 className="visually-hidden">क्रिकेट, फुटबॉल, हॉकी और अन्य खेलों की ताज़ा खबरें</h3> */}
      <div className="ak-container" style={{ transform: "none" }}>
        <div className="ak-content" style={{ transform: "none" }}>
          <div className="" style={{ transform: "none" }}>
            <div className='mt-2'>
              <BigAdd />
            </div>
            <div>
              <h1 className='head' style={{ color: 'crimson', marginLeft: 25 }}>
                खेल (खेल समाचार हिंदी में)
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div className="ak-archive-grid">
        <div className="">
          <div className="">
            <div className="ak-post-wrapper" style={{ transform: "none" }}>
              <div
                className="ak-content-wrap ak-post-wrap ak-layout-style-1 clearfix ak-post-style-7 clearfix"
                style={{ transform: "none" }}>
                <div className="ak-container" style={{ transform: "none" }}>
                  <div className="ak-content" style={{ transform: "none" }}>
                    <div
                      style={{ transform: "none" }}>
                      <div className="row" style={{ transform: "none" }}>
                        <div className="ak_column_1 col-md-9">
                          <div className="ak-article-inner">
                            <div className="">
                              <div className="row">
                                <div className="col-12 pb-1">
                                  <section className="row">
                                    <div className="col-12 col-md-6 pb-0 pb-md-3 pt-2 pr-md-1">
                                      <div
                                        id="featured"
                                        className="carousel slide carousel"
                                        data-ride="carousel"
                                      >
                                        <ol className="">
                                          <li
                                            data-target="#featured"
                                            data-slide-to={0}
                                            className="active"
                                          />
                                          <li
                                            data-target="#featured"
                                            data-slide-to={1}
                                          />
                                          <li
                                            data-target="#featured"
                                            data-slide-to={2}
                                          />
                                          <li
                                            data-target="#featured"
                                            data-slide-to={3}
                                          />
                                        </ol>

                                      </div>
                                    </div>

                                  </section>
                                </div>
                              </div>

                              <div className="row vc_row">
                                <div className="ak_vc_container">
                                  <div className="wpb_column ak_column_3 vc_column_container vc_col-sm-12">
                                    <div className="ak_vc_wrapper wpb_wrapper">
                                      <div
                                        className="ak-block ak-block-list-2-wide ak-block-column ak-block-module-inner-boxed ak-block-inner-border-round ak-block-module-thumb-round ak-block-width-4 clearfix"
                                        id="block_65f7f61f36732_2"
                                      >
                                        <div className="ak-block-inner clearfix">
                                          <div className="ak-block-posts clearfix">
                                            {news.map((newsItem) => {
                                              const htmlContent = isDesktop
                                                ? truncateHtml(newsItem.newsTag, 100) // Truncate only on desktop
                                                : newsItem.newsTag;
                                              return (
                                                <article key={newsItem.mainKhabarId} className="ak-module ak-module-2-wide ak-column-module ak-module-meta-hide ak-module-excerpt-hide clearfix post-225 post type-post status-publish format-standard has-post-thumbnail  category-business category-entertainment category-tech-science category-work-life tag-breaking tag-election tag-politics tag-technology tag-world-news" style={{ border: "0.5px solid #d4d4d4ff", marginBottom: "20px" }}>
                                                  <div className="ak-module-inner clearfix">
                                                    <div className="ak-module-featured">
                                                      <div className="ak-module-badges" />
                                                      <div className="ak-module-details mb-2">
                                                        <h2 className="ak-module-title">
                                                          <Link
                                                            to={`/News-Details/${newsItem.slug}`}
                                                            rel="bookmark"
                                                            aria-label={stripHtmlTags(newsItem.newsTag, 20)}
                                                            title={stripHtmlTags(newsItem.newsTag)}
                                                            onClick={async (e) => {
                                                              // Allow new tab/window actions
                                                              if (e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey) return;

                                                              e.preventDefault();
                                                              await handleNewsClick2(newsItem.slug, newsItem.mainKhabarId);
                                                            }}
                                                          >
                                                            <span
                                                              className="responsive-font"
                                                              style={{ lineHeight: "30px" }}
                                                              dangerouslySetInnerHTML={{ __html: htmlContent }}
                                                            />
                                                          </Link>
                                                        </h2>
                                                      </div>
                                                      <div className="ak-featured-cover">
                                                        <Link
                                                          to={`/News-Details/${newsItem.slug}`}
                                                          className="ak-featured-link"
                                                          rel="bookmark"
                                                          aria-label={stripHtmlTags(newsItem.newsTag)}
                                                          title={stripHtmlTags(newsItem.newsTag)}
                                                          onClick={async (e) => {
                                                            // Allow normal browser behavior for new tab / window
                                                            if (e.button === 1 || e.metaKey || e.ctrlKey || e.shiftKey) return;

                                                            e.preventDefault();
                                                            await handleNewsClick2(newsItem.slug, newsItem.mainKhabarId);
                                                          }}
                                                        >
                                                          <img
                                                            src={baseUrl + newsItem.newsImage}
                                                            alt={newsItem.slug}
                                                            width="410"
                                                            height="180"
                                                          />
                                                        </Link>
                                                      </div>
                                                    </div>
                                                  </div>

                                                </article>
                                              )
                                            })}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div id="load-more" style={{ textAlign: "center", padding: "20px" }}>
                              {fetching && <p>Loading more news...</p>}
                              {!hasMore && <p>No more news available.</p>}
                            </div>
                          </div>

                          <div className="mt-2">
                            <div className="pt-4">
                              <BigAdd />
                            </div>
                          </div>
                        </div>
                        <div
                          className="ak_column_ col-md-3 sidebar-column sidebar-column-primary-right sticky-sidebar"
                          style={{
                            position: "relative",
                            overflow: "visible",
                            boxSizing: "border-box",
                            minHeight: 1,
                          }}
                        >
                          <div
                            className="theiaStickySidebar"
                            style={{
                              paddingTop: 0,
                              paddingBottom: 1,
                              position: "sticky",
                              transform: "none",
                              top: 0,
                              left: "914.5px",
                            }}
                          >
                            <div className="sidebar post-sidebar">
                              <BollywoodNews2 />
                              <InternationalDetails2 />
                              {/* <TajaKhel1 />
                              <Football />
                              <SmallAdd />
                              <Hockey /> */}
                            </div>
                            <div
                              className="resize-sensor"
                              style={{
                                position: "absolute",
                                inset: 0,
                                overflow: "hidden",
                                zIndex: -1,
                                visibility: "hidden",
                              }}
                            >
                              <div
                                className="resize-sensor-expand"
                                style={{
                                  position: "absolute",
                                  left: 0,
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  overflow: "hidden",
                                  zIndex: -1,
                                  visibility: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    transition: "all 0s ease 0s",
                                    width: 410,
                                    height: 1260,
                                  }}
                                />
                              </div>
                              <div
                                className="resize-sensor-shrink"
                                style={{
                                  position: "absolute",
                                  left: 0,
                                  top: 0,
                                  right: 0,
                                  bottom: 0,
                                  overflow: "hidden",
                                  zIndex: -1,
                                  visibility: "hidden",
                                }}
                              >
                                <div
                                  style={{
                                    position: "absolute",
                                    left: 0,
                                    top: 0,
                                    transition: "0s",
                                    width: "200%",
                                    height: "200%",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Khels;
